import { Work } from '../types/interfaces'

export const works: Work[] = [
  {
    Name: 'Alfabit',
    Position: 'IT Application Specialist',
    HowLong: '12.2024 - present',
    Tasks: [
      'Programming network services and applications as well as websites for clients and business.',
      'Implementing wireless and cloud technologies (automation).',
      'Server administration and API/database management. Troubleshooting and technical customer support.',
    ],
  },
  {
    Name: 'Techgroup',
    Position: 'Telecommunications Technician',
    HowLong: '08.2025 - 09.2025',
    Tasks: [
      'Laying and installing fiber optic cables. Servicing and maintaining telecommunication networks.',
      'Configuring and maintaining network devices and home internet networks.',
      'Programming network services and applications.',
    ],
  },
  {
    Name: 'National Centre for Nuclear Research',
    Position: 'Intern in the nuclear equipment department',
    HowLong: '07.2025 - 08.2025',
    Tasks: [
      'Familiarization with creating, verifying, and validating technological documentation.',
      'Learning the basics of programming Siemens and Beckhoff PLC controllers.',
      'Creating and testing software for the AQURE accelerator in C++ and C# programming languages.',
      'Assembly and commissioning of electrical components of accelerators. Conducting functional tests.',
    ],
  },
  {
    Name: 'Elepotrik',
    Position: 'Engineer in an electronic service',
    HowLong: '08.2024 - 09.2024',
    Tasks: [
      'Diagnosing and repairing electronic devices, including computer and mobile equipment.',
      'Soldering and replacing electronic components. Operating diagnostic equipment.',
      'Conducting functional tests and repairing software in devices.',
      'Taking orders and contacting customers.',
    ],
  },
  {
    Name: 'Lewe Korki',
    Position: 'Project founder, tutor, full-stack developer',
    HowLong: '07.2023 - 05.2024',
    Tasks: [
      'Creating and maintaining an educational platform for tutors and organizing classes through it.',
      'Database management – organizing users and teaching materials.',
      'Tutoring high school students in physics and mathematics.',
    ],
  },
  {
    Name: 'Soulgraphy',
    Position: 'Creator and project leader, front-end developer',
    HowLong: '11.2020 - 07.2021',
    Tasks: [
      "Creating and developing a platform for political tests, allowing analysis of users' views.",
      'Managing a team of 20 people, organizing youth debates and interviews with politicians.',
      'Achieving tens of thousands of visits daily.',
      'Online platform presence – tests are still available at <a href="https://soulgraphy.me">Soulgraphy</a>.',
    ],
  },
]
